import { useState } from "react";
import { useCachedResource } from "../hooks/useCachedResource";
import { useTranslation } from "react-i18next";
import { Download, FileSpreadsheet } from "lucide-react";
import { AppShell } from "../components/layout/AppShell";
import { NeuButton } from "../components/neu/Neu";
import { exportMyLog, fetchHistory } from "../api/attendance";
import { HistoryList } from "../features/attendance/HistoryList";
import { LogSummary } from "../features/attendance/LogSummary";

const RANGES = [7, 30, 90];

export default function MyLogPage() {
  const { t, i18n } = useTranslation();
  const [days, setDays] = useState(30);
  const { data } = useCachedResource(`my-log-${days}`, () => fetchHistory(days), [days]);
  const records = data || [];

  return (
    <AppShell
      title={t("nav.myLog")}
      subtitle={t("log.subtitle")}
      actions={
        <div className="flex flex-wrap gap-2">
          <div className="flex gap-2" data-testid="log-ranges">
            {RANGES.map((value) => (
              <NeuButton
                key={value}
                data-testid={`log-range-${value}`}
                className={`px-4 py-2 text-xs ${days === value ? "text-primary shadow-neu-in" : ""}`}
                onClick={() => setDays(value)}
              >
                {t("log.lastDays", { count: value })}
              </NeuButton>
            ))}
          </div>
          <div className="flex gap-2" data-testid="log-exports">
            <NeuButton
              data-testid="log-export-excel"
              className="flex items-center gap-2 px-4 py-2 text-xs"
              onClick={() => exportMyLog(days, "xlsx", i18n.language)}
            >
              <FileSpreadsheet className="h-4 w-4" /> Excel
            </NeuButton>
            <NeuButton
              data-testid="log-export-pdf"
              className="flex items-center gap-2 px-4 py-2 text-xs"
              onClick={() => exportMyLog(days, "pdf", i18n.language)}
            >
              <Download className="h-4 w-4" /> PDF
            </NeuButton>
          </div>
        </div>
      }
    >
      <div className="grid gap-6">
        <LogSummary records={records} />
        <HistoryList records={records} />
      </div>
    </AppShell>
  );
}
